import React, { Component } from 'react';
import { ModalHeader, ModalFooter, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap'
import { MIS_FIELD_DATA_TYPE, MIS_FIELD_KEY_TYPE, MIS_FIELD_FORM_CATEGORY,MIS_FIELD_TYPE} from '../constants';
import { toast } from 'react-toastify';
import { validateCreateMisFieldForm, transformToMisFieldReqBody,transformToMasterKeySelectData } from './helper';
import Select from 'react-select'
class CreateMisFormFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            misFieldCreateForm: {
                name: '',
                formCategory: '',
                keyType: '',
                masterKey: '',
                dataType: '',
                fieldType:'',
                values: ''
            },
            selectedMasterKey:null,
            masterDataList:[]
        }
    }

   
    componentDidUpdate(prevProps) {
            if (this.props.masterDataList && this.props.masterDataList !== prevProps.masterDataList) {
                const tmpArr=transformToMasterKeySelectData(this.props.masterDataList);
                this.setState({
                    masterDataList:tmpArr
                })
            }
    }
    resetMisFieldCreateForm=()=>
    {
        this.setState({
            misFieldCreateForm: {
                name: '',
                formCategory: '',
                keyType: '',
                masterKey: '',
                dataType: '',
                fieldType:'',
                values: null
            },
            selectedMasterKey:null
        })
    }
    
    handleFormChange = (event) => {
        event.persist()
        switch (event.target.name) {
            case 'name':
                return this.setState((prevState) => ({
                    misFieldCreateForm: {
                        ...prevState.misFieldCreateForm,
                        name: event.target.value,
                    }
                }))
            case 'formCategory':
                return this.setState((prevState) => ({
                    misFieldCreateForm: {
                        ...prevState.misFieldCreateForm,
                        formCategory: event.target.value,
                    }
                }))
            case 'keyType':
                return this.setState((prevState) => ({
                    misFieldCreateForm: {
                        ...prevState.misFieldCreateForm,
                        keyType: event.target.value,
                        values: this.getValues(prevState.misFieldCreateForm, event.target.value)
                    }
                }))
            case 'dataType':
                return this.setState((prevState) => ({
                    misFieldCreateForm: {
                        ...prevState.misFieldCreateForm,
                        dataType: event.target.value
                    }
                }))
            case 'values':
                return this.setState((prevState) => ({
                    misFieldCreateForm: {
                        ...prevState.misFieldCreateForm,
                        values: event.target.value

                    }
                }))
            case 'fieldType':
                    return this.setState((prevState) => ({
                        misFieldCreateForm: {
                            ...prevState.misFieldCreateForm,
                            fieldType: event.target.value
                        }
                    }))
            default: return ''
        }
    }
    getValues = (form, value) => {
        if (value && value === 'SIMPLE')
            return null;
        return form.values;

    }
    handleCreate = () => {
        let errMsg = validateCreateMisFieldForm(this.state.misFieldCreateForm);
        if (errMsg === '') {
            const reqBody = transformToMisFieldReqBody(this.state.misFieldCreateForm);
            this.resetMisFieldCreateForm();
            this.props.createCallback(reqBody);
        }
        else {
            toast.warning(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{errMsg}
                </div>);
        }
    }
    handleMasterKeyChange=(e)=>{
        let masterKeyName=e && e.value? e.value:'';
        this.setState((prevState) => ({
            misFieldCreateForm: {
                ...prevState.misFieldCreateForm,
                masterKey: masterKeyName
            },
            selectedMasterKey:e
        }))
        
    }

    handleClose=()=>{
        this.resetMisFieldCreateForm();
        this.props.closeModal();
    }
    render() {
        return (
            <div>
                <ModalHeader>Create Mis Form Field</ModalHeader>
                <ModalBody>
                    <Form onChange={this.handleFormChange}>
                        <FormGroup>
                            <Label for="name">Name <span className='text-danger'>*</span></Label>
                            <Input type="text" name="name" id="name" placeholder="Enter Mis Field Name" value={this.state.misFieldCreateForm.name}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="keyType">Key Type<span className='text-danger'>*</span></Label>
                            <Input type="select" name="keyType" id="keyType" value={this.state.misFieldCreateForm.keyType}>
                                <option value=''>Select</option>
                                {
                                    MIS_FIELD_KEY_TYPE.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="formCategory">Form Category<span className='text-danger'>*</span></Label>
                            <Input type="select" name="formCategory" id="formCategory" value={this.state.misFieldCreateForm.formCategory}>
                                <option value=''>Select</option>
                                {
                                    MIS_FIELD_FORM_CATEGORY.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="dataType">Data Type<span className='text-danger'>*</span></Label>
                            <Input type="select" name="dataType" id="dataType" value={this.state.misFieldCreateForm.dataType}>
                                <option value=''>Select</option>
                                {
                                    MIS_FIELD_DATA_TYPE.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        {(this.state.misFieldCreateForm && this.state.misFieldCreateForm.keyType === 'OBJECT_LIST') ?
                            <FormGroup>
                                <Label for="values">Allowed Values</Label>
                                <Input type="text-area" name="values" id="values" placeholder="Enter Coma seperated Values ex: (value1,value2)" value={this.state.misFieldCreateForm.values} />
                            </FormGroup> : null
                        }
                        <FormGroup>
                            <Label for="fieldType">Field Type<span className='text-danger'>*</span></Label>
                            <Input type="select" name="fieldType" id="fieldType" value={this.state.misFieldCreateForm.fieldType}>
                                <option value=''>Select</option>
                                {
                                    MIS_FIELD_TYPE.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Form>
                    <Form>
                    <FormGroup>
                            <Label for="masterKey">Master Key</Label>
                            <Select
                                value={this.state.selectedMasterKey}
                                options={this.state.masterDataList}
                                onChange={this.handleMasterKeyChange}
                                maxMenuHeight={100}
                                placeholder="Choose Master Key"/>
                    </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.handleClose}>Close</Button>
                    <Button color="primary" onClick={this.handleCreate}>Add</Button>
                </ModalFooter>
            </div >
        )
    }
}

export default CreateMisFormFields